module.exports = __webpack_public_path__ + "static/img/MR2.354c91b6.png";